import { Translate } from 'next-translate';
import { EditOutlined, PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { DEFAULT_MAX_ADDER_COLUMN_COUNT } from '@utils/line-items/columnHelpers';

interface GetInitSettingsParams {
  isOverAdderLimit?: boolean;
  isOverLimit: boolean;
  isReadOnly: boolean;
  maxAdderColumnCount?: number;
  maxDescriptiveColumnCount: number;
  t: Translate;
}

interface Item {
  icon: JSX.Element;
  name: string;
  tooltip?: string;
}

interface InitSettings {
  addAdderColumn: Item;
  addColumn: Item;
  editColumn: Item;
  removeColumn: Item;
}

export const getInitSettings = ({
  isOverAdderLimit = false,
  isOverLimit,
  isReadOnly,
  maxAdderColumnCount = DEFAULT_MAX_ADDER_COLUMN_COUNT,
  maxDescriptiveColumnCount,
  t,
}: GetInitSettingsParams): InitSettings => {
  let addColumnName = t('bid_request.line_items.dropdown.add_column');
  const addColumnIcon = <PlusCircleOutlined />;
  let addColumnTooltip;

  const editColumnName = t('bid_request.line_items.dropdown.edit_column');
  const editColumnIcon = <EditOutlined />;

  const removeColumnName = t('bid_request.line_items.dropdown.remove_column');
  const removeColumnIcon = <DeleteOutlined />;

  if (isReadOnly) {
    addColumnTooltip = t('bid_request.line_items.tooltips.disabled_action', {
      action: t('bid_request.line_items.tooltips.actions.add_visible_columns'),
    });
    addColumnName = t('bid_request.line_items.dropdown.add_hidden_column');
  }
  if (isOverLimit) {
    addColumnTooltip = t('bid_request.line_items.dropdown.tooltip.column_max_total', { max: maxDescriptiveColumnCount });
  }

  const addAdderColumnName = t('bid_request.line_items.dropdown.add_pricing_column');
  // Read-only (quote-received) takes precedence over the over-limit tooltip.
  // Note: this diverges from descriptive/custom column behaviour above — those
  // stay clickable and rename to "Add Hidden Column" when read-only. Pricing
  // columns are always supplier-visible, so we fully disable the entry instead.
  let addAdderColumnTooltip: string | undefined;
  if (isReadOnly) {
    addAdderColumnTooltip = t('bid_request.line_items.tooltips.disabled_action', {
      action: t('bid_request.line_items.tooltips.actions.add_pricing_columns'),
    });
  } else if (isOverAdderLimit) {
    addAdderColumnTooltip = t('bid_request.line_items.dropdown.tooltip.adder_column_max_total', { max: maxAdderColumnCount });
  }

  return {
    addAdderColumn: { icon: addColumnIcon, name: addAdderColumnName, tooltip: addAdderColumnTooltip },
    addColumn: { icon: addColumnIcon, name: addColumnName, tooltip: addColumnTooltip },
    editColumn: { icon: editColumnIcon, name: editColumnName },
    removeColumn: { icon: removeColumnIcon, name: removeColumnName },
  };
};
